var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleMapLoader',{attrs:{"mapConfig":_vm.mapConfig,"apiKey":_vm.apiKey},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
return [_c('GoogleMapMarker',_vm._g({key:_vm.crosswalk._id,attrs:{"marker":_vm.marker(_vm.crosswalk),"google":google,"map":map}},_vm.crosswalk))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }